module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_intro01-c99b54f2591c30fb0b4c0ede1893d0a2.jpg";